import React, {useEffect, useRef, useState} from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Text, Span, Box, Button, Icon, Section} from "@quarkly/widgets";
import {IoIosCheckmark} from "react-icons/io";
import {Input, Modal, Select, Space, Tooltip} from "antd";
import {CreditCardOutlined, InfoCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {useSearchParams} from "../hook/useSearchParams";
import {priceMonthly} from "../priceData";
import {useReferralCode} from "./ReferralHandler";

const defaultProps = {
    "padding": "60px 0",
    "background": "transparent",
    "color": "#ffffff"
};

const overrides = {};

const CdzvPricingRU = props => {
    const {getReferralCode} = useReferralCode();
    const {override, children, rest} = useOverrides(props, overrides, defaultProps);
    
    const [isPayModalOpen, setIsPayModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [tvName, setTvName] = useState('');
    const [userLang, setUserLang] = useState('ru');
    const [loading, setLoading] = useState(false);
    const [paymentType, setPaymentType] = useState(1);
    const [errorMsg, setErrorMsg] = useState('');

    const emailInputRef = useRef(null);

    const searchParams = useSearchParams();
    const pay = searchParams.get('pay');
    const pay_id = searchParams.get('pid');
    const utm_medium = searchParams.get('utm_medium');
    const utm_source = searchParams.get('utm_source');
    const utm_campaign = searchParams.get('utm_campaign');
    const utm_content = searchParams.get('utm_content');

    useEffect(() => {
        if (pay === 'sxiniosax') {
            const element = document.getElementById('aichat');
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }, [pay]);

    useEffect(() => {
        if (isPayModalOpen && emailInputRef.current) {
            setTimeout(() => {
                emailInputRef.current.focus();
            }, 100);
        }
    }, [isPayModalOpen]);

    function getCurrentPrice(index) {
        return priceMonthly[index];
    }

    function redirectToMainPage() {
        window.location.href = 'https://panel.cdzv.com/';
    }

    async function postTelegramData(data = {}) {
        const url = 'https://kslukgrih5xid2ijqazpczomae0qkbbi.lambda-url.eu-central-1.on.aws/';
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            redirect: "follow",
            body: JSON.stringify(data)
        });
        return await response.json();
    }

    async function postApiData(data = {}) {
        const url = 'https://api.cdzv.com/';
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            redirect: "follow",
            body: JSON.stringify(data)
        });
        return await response.json();
    }

    const handleFormSubmit = async () => {
        setErrorMsg('');
        const refCode = getReferralCode() || '';
        
        let finalTvName = tvName.trim();
        if (!finalTvName) {
            finalTvName = 'none';
        }

        const emailTrimmed = email.trim();
        if (!emailTrimmed || emailTrimmed.length < 5 || !emailTrimmed.includes('@') || !emailTrimmed.includes('.')) {
            setErrorMsg('Пожалуйста, введите корректный адрес e-mail.');
            return;
        }

        setLoading(true);

        if (window.js_track) {
            window.js_track(emailTrimmed);
        }

        try {
            await postTelegramData({
                action: 'new_user',
                email: emailTrimmed,
                tv_user: finalTvName,
                type: getCurrentPrice(paymentType).package_id,
                package: getCurrentPrice(paymentType).name,
                lang: userLang,
                ref_code: refCode
            });

            await postApiData({
                action: 'new_user',
                email: emailTrimmed,
                tv_user: finalTvName,
                type: getCurrentPrice(paymentType).package_id,
                package: getCurrentPrice(paymentType).name,
                lang: userLang,
                ref_code: refCode
            });

            window.location.href = getCurrentPrice(paymentType).url + 
                '?email=' + emailTrimmed + 
                '&prefilled_email=' + emailTrimmed + 
                '&utm_medium=' + emailTrimmed.replace('@', '_').replace('.', '-') + 
                '&utm_source=' + finalTvName.replace('@', '_').replace('.', '-') + 
                '&utm_campaign=' + getCurrentPrice(paymentType).package_id + 
                '&utm_content=' + userLang;
        } catch (e) {
            console.error(e);
            setErrorMsg('Произошла ошибка при отправке данных. Пожалуйста, попробуйте еще раз.');
            setLoading(false);
        }
    };

    const showConfirmPayment = () => {
        Modal.info({
            title: 'Поздравляем с успешной подпиской!',
            width: 650,
            content: (
                <div style={{ padding: '10px 0', fontSize: '15px', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.85)' }}>
                    <strong>E-Mail:</strong> {utm_medium ? utm_medium.replace('_', '@').replace('-', '.') : ''}<br/>
                    <strong>TradingView:</strong> {utm_source ? utm_source.replace('_', '@').replace('-', '.') : ''}<br/><br/>
                    Вы успешно оформили подписку.<br/><br/>
                    Мы создаем Ваш личный кабинет и активируем премиум-модуль <strong>SMART Grid PRO</strong>. Обычно это занимает до 1 минуты.<br/><br/>
                    Письмо с инструкциями по доступу и активации индикаторов в TradingView отправлено на вашу почту.
                </div>
            ),
            footer: () => (
                <div style={{ textAlign: 'center', fontWeight: '600', color: '#fbbf24', padding: '10px' }}>
                    Перенаправление в кабинет через несколько секунд...
                </div>
            )
        });

        try {
            postTelegramData({
                action: 'payment',
                email: utm_medium.replace('_', '@').replace('-', '.'),
                tv_user: utm_source.replace('_', '@').replace('-', '.'),
                package: utm_campaign,
            });
        } catch (e) {
            console.log(e);
        }

        try {
            postApiData({
                action: 'payment',
                email: utm_medium.replace('_', '@').replace('-', '.'),
                tv_user: utm_source.replace('_', '@').replace('-', '.'),
                package: utm_campaign,
                payid: pay_id,
                lang: utm_content
            });
        } catch (e) {
            console.log(e);
        }

        setTimeout(() => {
            redirectToMainPage();
        }, 15000);
    };

    return (
        <Section {...rest} style={{ background: 'transparent', padding: '80px 20px', fontFamily: 'inherit' }}>
            {pay && showConfirmPayment()}
            
            <style dangerouslySetInnerHTML={{__html: `
                .pricing-container {
                    max-width: 1100px;
                    margin: 0 auto;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 40px;
                    padding-top: 40px;
                }
                .pricing-card {
                    background: rgba(255, 255, 255, 0.02);
                    border: 1px solid rgba(255, 255, 255, 0.06);
                    border-radius: 24px;
                    padding: 48px;
                    display: flex;
                    flex-direction: column;
                    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
                    backdrop-filter: blur(12px);
                }
                .pricing-card:hover {
                    transform: translateY(-6px);
                    border-color: rgba(138, 43, 226, 0.3);
                    box-shadow: 0 20px 50px rgba(138, 43, 226, 0.15);
                    background: rgba(255, 255, 255, 0.04);
                }
                .pricing-card.premium {
                    background: linear-gradient(180deg, rgba(138, 43, 226, 0.08) 0%, rgba(10, 3, 20, 0.6) 100%);
                    border-color: rgba(138, 43, 226, 0.25);
                    box-shadow: 0 15px 45px rgba(138, 43, 226, 0.1);
                }
                .pricing-card.premium:hover {
                    border-color: rgba(138, 43, 226, 0.6);
                    box-shadow: 0 25px 60px rgba(138, 43, 226, 0.25);
                    background: linear-gradient(180deg, rgba(138, 43, 226, 0.12) 0%, rgba(10, 3, 20, 0.7) 100%);
                }
                .pricing-card.premium::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, rgba(138, 43, 226, 0.12) 0%, transparent 60%);
                    pointer-events: none;
                }
                .badge {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    background: rgba(255, 255, 255, 0.08);
                    border: 1px solid rgba(255, 255, 255, 0.15);
                    padding: 6px 14px;
                    border-radius: 30px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                }
                .badge.popular {
                    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%);
                    border: none;
                    box-shadow: 0 4px 12px rgba(138, 43, 226, 0.3);
                }
                .plan-title {
                    font-size: 26px;
                    font-weight: 700;
                    margin-bottom: 10px;
                    letter-spacing: -0.5px;
                }
                .plan-desc {
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.7);
                    line-height: 1.5;
                    margin-bottom: 25px;
                    min-height: 45px;
                }
                .plan-price-box {
                    margin-bottom: 30px;
                    display: flex;
                    align-items: baseline;
                }
                .plan-price {
                    font-size: 54px;
                    font-weight: 800;
                    letter-spacing: -2px;
                    line-height: 1;
                    background: linear-gradient(135deg, #ffffff 0%, #c084fc 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .plan-period {
                    font-size: 16px;
                    color: rgba(255, 255, 255, 0.6);
                    margin-left: 8px;
                }
                .features-list {
                    list-style: none;
                    padding: 0;
                    margin: 0 0 35px 0;
                    flex-grow: 1;
                }
                .feature-item {
                    display: flex;
                    align-items: flex-start;
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.85);
                    margin-bottom: 14px;
                    line-height: 1.4;
                }
                .feature-icon {
                    color: #4ade80;
                    font-size: 22px;
                    margin-right: 10px;
                    flex-shrink: 0;
                    margin-top: -1px;
                }
                .feature-icon.highlight {
                    color: #fbbf24;
                }
                .btn-action {
                    display: block;
                    width: 100%;
                    padding: 16px;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 700;
                    text-align: center;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    border: none;
                    cursor: pointer;
                    margin-bottom: 12px;
                }
                .btn-action:last-child {
                    margin-bottom: 0;
                }
                .btn-action.free-dl {
                    background: rgba(255, 255, 255, 0.06);
                    color: #ffffff;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                }
                .btn-action.free-dl:hover {
                    background: rgba(255, 255, 255, 0.12);
                    border-color: rgba(255, 255, 255, 0.25);
                }
                .btn-action.subscribe {
                    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%);
                    color: #ffffff;
                    box-shadow: 0 6px 20px rgba(138, 43, 226, 0.3);
                }
                .btn-action.subscribe:hover {
                    box-shadow: 0 8px 25px rgba(138, 43, 226, 0.5);
                    transform: scale(1.02);
                }
                
                /* Dark Theme Ant Design Modal Styles */
                .ant-modal-content {
                    background: #0f081d !important;
                    border: 1px solid rgba(255, 255, 255, 0.08) !important;
                    border-radius: 20px !important;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6) !important;
                }
                .ant-modal-header {
                    background: transparent !important;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
                    padding-bottom: 16px !important;
                }
                .ant-modal-title {
                    color: #ffffff !important;
                    font-size: 20px !important;
                    font-weight: 700 !important;
                }
                .ant-modal-close {
                    color: rgba(255, 255, 255, 0.4) !important;
                }
                .ant-modal-close:hover {
                    color: #ffffff !important;
                }
                .ant-input {
                    background: rgba(255, 255, 255, 0.03) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    color: #ffffff !important;
                    height: 44px !important;
                    border-radius: 10px !important;
                }
                .ant-input:focus, .ant-input-focused {
                    border-color: #8a2be2 !important;
                    box-shadow: 0 0 0 2px rgba(138, 43, 226, 0.2) !important;
                }
                .ant-select-selector {
                    background: rgba(255, 255, 255, 0.03) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    color: #ffffff !important;
                    border-radius: 10px !important;
                }
                .ant-select-single .ant-select-selector {
                    height: 44px !important;
                    display: flex !important;
                    align-items: center !important;
                }
                .ant-select-dropdown {
                    background: #0f081d !important;
                    border: 1px solid rgba(255, 255, 255, 0.08) !important;
                    border-radius: 10px !important;
                }
                .ant-select-item {
                    color: rgba(255, 255, 255, 0.8) !important;
                }
                .ant-select-item-option-selected {
                    background: rgba(138, 43, 226, 0.25) !important;
                    color: #ffffff !important;
                }
                .ant-select-item-option-active {
                    background: rgba(255, 255, 255, 0.05) !important;
                }
                .ant-select {
                    color: #ffffff !important;
                }
                .ant-select-arrow {
                    color: rgba(255, 255, 255, 0.4) !important;
                }
                .ant-modal-body p {
                    color: rgba(255, 255, 255, 0.7) !important;
                }
                
                @media (max-width: 768px) {
                    .pricing-container {
                        grid-template-columns: 1fr;
                        gap: 30px;
                    }
                    .pricing-title {
                        font-size: 30px !important;
                        margin-bottom: 10px !important;
                    }
                    .pricing-desc {
                        font-size: 15px !important;
                    }
                }
            `}} />

            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 className="pricing-title" style={{ fontSize: '42px', fontWeight: '800', marginBottom: '15px', color: '#ffffff', letterSpacing: '-1px' }}>
                    Простые и честные условия
                </h2>
                <p className="pricing-desc" style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)', maxWidth: '650px', margin: '0 auto', lineHeight: '1.6' }}>
                    Используйте инструменты бесплатно. Оплачивайте Webhook-сервер только тогда, когда вам действительно нужна автоматизация торговли.
                </p>
            </div>

            <div className="pricing-container">
                {/* Free Tools Card */}
                <div className="pricing-card">
                    <span className="badge">100% Бесплатно</span>
                    <h3 className="plan-title">CDZV Бесплатный набор</h3>
                    <p className="plan-desc">
                        Собирайте собственные торговые стратегии в визуальном редакторе и легко ребалансируйте портфель.
                    </p>
                    <div className="plan-price-box">
                        <span className="plan-price">$0</span>
                        <span className="plan-period">навсегда</span>
                    </div>
                    <ul className="features-list">
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span><strong>CDZV Toolkit</strong> — визуально собирайте условия входа и выхода прямо на графике TradingView</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span><strong>Coin Rebalancer</strong> — модуль, который каждые 15 минут проверяет веса монет и подравнивает ваш портфель</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Авторские индикаторы CDZV для точного определения трендовых зон</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Проверка ваших идей на истории котировок за 3 клика без риска реальными деньгами</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>5 готовых шаблонов стратегий, которые можно сразу запустить в работу</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Общение и помощь с настройками в нашем Telegram-чате</span>
                        </li>
                    </ul>
                    <div>
                        <a 
                            href="https://t.me/c/cdzv_com/35178" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="btn-action free-dl"
                        >
                            Скачать CDZV Toolkit (Telegram)
                        </a>
                        <a 
                            href="https://t.me/cdzv_com/13302/35129" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="btn-action free-dl"
                            style={{ background: 'rgba(74, 222, 128, 0.04)', borderColor: 'rgba(74, 222, 128, 0.2)' }}
                        >
                            Скачать Coin Rebalancer (Telegram)
                        </a>
                    </div>
                </div>

                {/* Webhook Server Subscription Card */}
                <div className="pricing-card premium">
                    <span className="badge popular">Выгодный комплект</span>
                    <h3 className="plan-title">Webhook Server + SMART Grid PRO</h3>
                    <p className="plan-desc">
                        Полное автоисполнение ваших сигналов на биржах 24/7 и эксклюзивный доступ к сеточным ордерам.
                    </p>
                    <div className="plan-price-box">
                        <span className="plan-price">$40</span>
                        <span className="plan-period">в месяц</span>
                    </div>
                    <ul className="features-list">
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon highlight" />
                            <span><strong>SMART Grid PRO (Включено!)</strong> — доступ к сеточному алгоритму, который автоматически усредняет цену при просадках</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon highlight" style={{ color: '#8a2be2' }} />
                            <span>Личный кабинет пользователя, где SMART Grid PRO активируется автоматически после оплаты</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Мгновенное исполнение сигналов с графиков TradingView на вашем аккаунте Binance, Bybit или OKX</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Ваши стратегии торгуют круглосуточно. Компьютер или телефон держать включенными не нужно</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Автоматическое подключение к Bybit, Binance, OKX через безопасные API-ключи</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Прямая связь с разработчиком в Telegram при любых трудностях с настройкой</span>
                        </li>
                    </ul>
                    <button 
                        onClick={() => {
                            setPaymentType(1);
                            setIsPayModalOpen(true);
                        }}
                        className="btn-action subscribe"
                    >
                        Оформить подписку через Stripe
                    </button>
                </div>
            </div>

            {/* Reactive Dark-Glassmorphic Payments Modal */}
            <Modal
                title="Регистрация кабинета и переход к оплате"
                visible={isPayModalOpen}
                onCancel={() => setIsPayModalOpen(false)}
                footer={[
                    <Button 
                        key="cancel" 
                        onClick={() => setIsPayModalOpen(false)}
                        style={{ 
                            background: 'rgba(255, 255, 255, 0.05)', 
                            border: '1px solid rgba(255, 255, 255, 0.1)', 
                            color: '#ffffff',
                            borderRadius: '8px',
                            height: '40px'
                        }}
                    >
                        Отмена
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        disabled={loading}
                        onClick={handleFormSubmit}
                        style={{
                            background: 'linear-gradient(135deg, #8a2be2 0%, #4b0082 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(138, 43, 226, 0.3)',
                            height: '40px',
                            fontWeight: '600'
                        }}
                    >
                        <CreditCardOutlined /> Оплатить картой через Stripe
                    </Button>
                ]}
                width={550}
                centered
            >
                <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: '15px' }}>
                    <p style={{ fontSize: '14px', lineHeight: '1.5', margin: 0 }}>
                        Введите свои данные. Мы создадим для вас личный кабинет, где после оплаты будет активирован доступ к <strong>SMART Grid PRO</strong>.
                    </p>
                    
                    {errorMsg && (
                        <div style={{ color: '#ef4444', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.2)', padding: '10px 14px', borderRadius: '8px', fontSize: '13px' }}>
                            {errorMsg}
                        </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <span style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.5)' }}>E-Mail *</span>
                        <Input
                            ref={emailInputRef}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Ваш e-mail"
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <span style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.5)' }}>Никнейм в TradingView</span>
                        <Input
                            value={tvName}
                            onChange={(e) => setTvName(e.target.value)}
                            placeholder="Ваш никнейм в TradingView"
                        />
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <span style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.5)' }}>Язык кабинета</span>
                        <Select
                            value={userLang}
                            style={{ width: '100%' }}
                            options={[
                                { value: 'en', label: 'English' },
                                { value: 'ua', label: 'Українська' },
                                { value: 'ru', label: 'Русский' }
                            ]}
                            onChange={(value) => setUserLang(value)}
                        />
                    </div>

                    <p style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.45)', lineHeight: '1.4', margin: '5px 0 0 0' }}>
                        <InfoCircleOutlined style={{ color: '#8a2be2', marginRight: '4px' }}/> Если у Вас нет аккаунта TradingView, впишите '<strong>none</strong>'.<br/>
                        <InfoCircleOutlined style={{ color: '#8a2be2', marginRight: '4px' }}/> Пишите нам на <strong><a href="mailto:support@cdzv.com" style={{ color: '#8a2be2' }}>support@cdzv.com</a></strong> при любых трудностях.
                    </p>
                </Space>
            </Modal>
            
            {children}
        </Section>
    );
};

Object.assign(CdzvPricingRU, {
    ...Section,
    defaultProps,
    overrides
});

export default CdzvPricingRU;